"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("@requestnetwork/types");
const utils_1 = require("@requestnetwork/utils");
/**
 * Function to manage Request Logic Role
 */
exports.default = {
    getRole,
};
/**
 * Function to get the role of an identity in an object
 *
 * @param any parameters the object to check
 * @param IIdentity identity the identity to check
 *
 * @returns Types.ROLE the role of identity in parameters
 */
function getRole(identity, parameters) {
    if (parameters.payee && (0, utils_1.areEqualIdentities)(parameters.payee, identity)) {
        return types_1.RequestLogicTypes.ROLE.PAYEE;
    }
    if (parameters.payer && (0, utils_1.areEqualIdentities)(parameters.payer, identity)) {
        return types_1.RequestLogicTypes.ROLE.PAYER;
    }
    return types_1.RequestLogicTypes.ROLE.THIRD_PARTY;
}
